import {QueryClient, QueryClientProvider} from '@tanstack/react-query'
import {ReactQueryDevtools} from '@tanstack/react-query-devtools'
import {ConnectedRouter} from 'connected-react-router'
import React, {Component, Fragment} from 'react'
import {render} from 'react-dom'
import Modal from 'react-modal'
import {Provider} from 'react-redux'

import history from '../history'

import OnboardingModalContainer from '../components/Onboarding/OnboardingModalContainer'
import SlidingFullScreenModal from '../components/SlidingFullScreenModal'
import ConfirmationModalContainer from '../containers/ConfirmationModalContainer'
import DashboardContainer from '../containers/DashboardContainer'
import HelloBarConductorContainer from '../containers/HelloBarConductorContainer'
import MobileMenuContainer from '../containers/MobileMenuContainer'
import ModalConductorContainer from '../containers/ModalConductorContainer'
import NearestShowroomLocationBannerContainer from '../containers/NearestShowroomLocationBannerContainer'
import {CartContextProvider} from '../contexts/CartContext'

import {Header, SiteFooter} from '../routes/asyncRouteComponents'
import PageRoutes from '../routes/PageRoutes'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
})

class Root extends Component {
  constructor(props) {
    super(props)
    this.siteEl = React.createRef()
  }

  componentDidMount() {
    // react-modal allows you to specify the portion of your app that should be hidden via aria-hidden, to
    // prevent assistive technologies such as screenreaders from reading content outside of the content of your modal.
    // ** Logs a warning if not set **
    // https://github.com/SherylHohman/react-modal#app-element
    Modal.setAppElement(this.siteEl.current)
  }

  render() {
    return (
      <Provider store={TBT.store}>
        <QueryClientProvider client={queryClient}>
          <CartContextProvider>
            <ConnectedRouter history={history}>
              <Fragment>
                <DashboardContainer />
                <SlidingFullScreenModal />
                <ConfirmationModalContainer />
                <OnboardingModalContainer />
                <MobileMenuContainer />
                <ModalConductorContainer />
                <div className="site" ref={this.siteEl}>
                  <Header />
                  <NearestShowroomLocationBannerContainer />
                  <HelloBarConductorContainer />
                  <div className="site-content-and-footer js--move-when-screen-is-locked">
                    <main className="site-content">
                      <PageRoutes />
                    </main>
                    <SiteFooter />
                  </div>
                </div>
              </Fragment>
            </ConnectedRouter>
          </CartContextProvider>
          <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
      </Provider>
    )
  }
}

const rootEl = document.getElementById('react-root')

render(<Root />, rootEl)

// Here is the magic code to enable hot reloading of component code.
// First, check for module.hot, which will exist only if we are running off of the Webpack
// Dev Server with HMR enabled.
if (module.hot) {
  // This is a call to the Webpack HMR API: https://webpack.js.org/api/hot-module-replacement/#accept-self-
  // It tells Webpack that whenever this module or any of its dependencies are updated, we
  // can accept the updates by simply re-evaluating this module (which will re-mount the main
  // component tree with the updated code). Therefore, no page refresh is needed.
  module.hot.accept()
}

// binds the store to window for Cypress so we can access redux state in Cypress
if (window.Cypress) {
  window.store = TBT.store
}
